import React from "react";
import "./TicketsCard.css";
import { Globals as OldGlobals } from "../../global/Globals";
import { useNavigate } from "react-router-dom";
import '../Button/Button';
import { useLanguage } from "../../context/Languagecontext";

const TicketsCard = (props) => {
  const navigate = useNavigate();
   const { Globals ,languages, setLanguages } = useLanguage();
  const date = new Date(props.data.createdOn);
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0];

  const resolvedDate = new Date(props.data.resolvedOn);
  const resolvedDateString = new Date(resolvedDate.getTime() - resolvedDate.getTimezoneOffset() * 60000).toISOString().split("T")[0];

  const dateformat = (datestring) => {
    const date = new Date(datestring);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const resolvedDateformat = (resolvedDateString) => {
    const date1 = new Date(resolvedDateString);
    const day = date1.getDate();
    const month = date1.toLocaleString("default", { month: "short" });
    const year = date1.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const statusClass = props.data.status === 0 ? "active" : props.data.status === 1 ? "resolved" : "";

  const viewTicket = () => {
    navigate(OldGlobals.NAVPATH.TICKET_DETAILS,{
      state: {
        ticketId: props.data.ticketId,
        proposalId: props.data.proposalId,
        proposalDetailId: props.data.proposalDetailId,
        proposalType: props.data.proposalType,
        producerId: props.data.createdBy
      }
    })
  }

  return (
    <>
      <div class="ticket_Card">
        <div class="ticket_cardheader">
          <div class="ticket_title">
            <div className="ticket_detail-header Brief">
              <div className="ticket_title-heading">
                {Globals.TICKETS_DETAIL.TICKET_NO} :
              </div>
              <div class="ticket_title-heading" title={props.data.ticketNo}>
                {props.data.ticketNo}
              </div>
            </div>

          </div>
        </div>

        <div class="ticket_details">
          <div className="ticket_detail-header Brief">
            <div className="ticket_detail-title">
              {Globals.TICKETS_DETAIL.PRODUCER}
            </div>{" "}
            <div className="ticket_detail-value" title={props.data.producerName}>
              {props.data.producerName}
            </div>
          </div>
          <div className="ticket_seperator"></div>
          <div className="ticket_detail-header type">
            <div className="ticket_detail-title">
              {Globals.TICKETS_DETAIL.TICKET_TYPE}
            </div>{" "}
            <div className="ticket_detail-value" title={props.data.ticketType}>
              {props.data.ticketType}
            </div>
          </div>
          <div className="ticket_seperator"></div>
          <div className="ticket_detail-header format">
            <div className="ticket_detail-title">
              {props.data.ticketType === Globals.TICKET_TYPE.PROPOSAL ? Globals.TICKETS_DETAIL.PROPOSAL_NO : props.data.ticketType === Globals.TICKET_TYPE.BRIEF ? Globals.TICKETS_DETAIL.BRIEF_NO : Globals.TICKETS_DETAIL.CATEGORY }
            </div>{" "}
            <div className="ticket_detail-value" title={props.data.refNo}>
              {props.data.ticketType === Globals.TICKET_TYPE.PROPOSAL  || props.data.ticketType === Globals.TICKET_TYPE.BRIEF ? props.data.refNo : props.data.ticketType === Globals.TICKET_TYPE.OTHER ? props.data.category : ''}
            </div>
          </div>
          <div className="ticket_seperator"></div>
          <div className="ticket_detail-header genre">
            <div className="ticket_detail-title">
              {Globals.TICKETS_DETAIL.CREATED_ON}
            </div>{" "}
            <div className="ticket_detail-value" title={props.data.createdOn}>
              {dateformat(dateString)}
            </div>
          </div>
          <div className="ticket_seperator"></div>
          <div className="ticket_detail-header language">
            <div className="ticket_detail-title">
              {Globals.TICKETS_DETAIL.RESOLVED_ON}
            </div>{" "}
            <div className="ticket_detail-value" title={props.data.resolvedOn}>
              {props.data.resolvedOn === '0001-01-01T00:00:00' ? 'N/A' : resolvedDateformat(resolvedDateString)}
            </div>
          </div>
          <div className="ticket_seperator"></div>
          <div className="ticket_detail-header closing_date_ticket">
            <div className="ticket_detail-title">
              {Globals.TICKETS_DETAIL.STATUS}
            </div>
            <div className={`ticket_detail-value-${statusClass}`} title={props.data.status}>
              {props.data.status === 0 ? Globals.TICKETS_STATUS.ACTIVE : Globals.TICKETS_STATUS.RESOLVED}
            </div>
          </div>
        </div>
        <button title="View Ticket" onClick={viewTicket} className="basic-button apply-buttonPottraitcard">{Globals.TICKETS_PAGE.VIEW_TICKET}</button>
      </div>
    </>
  );
};

export default TicketsCard;